import React from 'react'

const Role = ({ data }) => {
  return (
    <div>
      <hr />
      <h2>
        {' '}
        {data.role} - <a href={data.link}>{data.name}</a>
      </h2>

      <h3>
        {data.start} - {data.end}
      </h3>
      <ul>
        {data.achievements.map((item) => (
          <li>{item}</li>
        ))}
      </ul>
      <p>
        Environment and technologies <br/>
        {data.technologies.map((item) => item + ", ")}
      </p>
    </div>
  )
}

const RoleList = ({ dataSource }) => {
  return (
    <div>
      {dataSource.map((item) => (
        <Role data={item} />
      ))}
    </div>
  )
}

export default RoleList
